import { useCallback } from "react"
import { API_ROUTES } from "../../configuration/RoutesApi"
import { GetRequest } from "../../services/ApiClientService"
import { SubscriptionPlanPricing } from "../../Objects/Company/SubscriptionPlanPricing"

export const useSubscriptionPlans = () => {
  const getSubscriptionPlans = useCallback(async () => {
    const response = await GetRequest<SubscriptionPlanPricing[]>(API_ROUTES.SUBSCRIPTION.PLANS)

    if (!response.success) {
      throw new Error(response.message)
    }

    return (response.data ?? []).map((item) => new SubscriptionPlanPricing(item))
  }, [])

  return {
    getSubscriptionPlans,
  }
}
